import React, {ReactElement, useEffect, useState} from 'react';
import RupeesIcon from '../../../assets/images/rupees.svg';
import MinusIcon from '../../../assets/images/minus.svg';
import PlusIcon from '../../../assets/images/plus.svg';
import MinusDisabledIcon from '../../../assets/images/minus_disabled.svg';
import {useAppDispatch} from '../../../redux/hooks';
import {OrderResponse} from '../../../lib/order-types';
import {getMetadata} from '../../../core/localstorage-data';

type AddBagProps = {
  type?: string;
  onProceedWithoutBag: () => void;
  onConfirm: (quantity: number) => void;
  orderResp: OrderResponse | null;
};
const AddBag: React.FC<AddBagProps> = ({
  type,
  onProceedWithoutBag,
  onConfirm,
  orderResp,
}: AddBagProps): ReactElement => {
  let BAG_PRICE = 0;
  const [count, setCount] = useState(
    orderResp && orderResp.carryBagItem ? orderResp.carryBagItem.quantity : 0,
  );
  const metaData = getMetadata();
  const bagMetaData = metaData.find(
    (obj: {name: string}) => obj.name === 'bag-price',
  );
  if (bagMetaData) {
    BAG_PRICE = bagMetaData.value;
  }
  const [bagAmount, setBagAmount] = useState(
    orderResp && orderResp.carryBagItem
      ? orderResp.carryBagItem.quantity * BAG_PRICE
      : 0,
  );

  function incrementCounter() {
    setCount(count + 1);
    setBagAmount(BAG_PRICE * (count + 1));
  }

  function decrementCounter() {
    setCount(count - 1);
    setBagAmount(BAG_PRICE * (count - 1));
  }

  function handleProceedWithoutBag() {
    setCount(0);
    setBagAmount(0);
    onProceedWithoutBag();
  }

  function handleConfirm() {
    onConfirm(count);
    // dispatch(setCarryBagTotal(bagAmount));
  }

  return (
    <div className="px-4 pb-4">
      <div className="relative">
        <span className="font-medium block font-roboto text-center">
          Would you like to add a carry bag?
        </span>
      </div>
      <div className="flex justify-between text-small pt-5 font-roboto">
        <div>Select quantity</div>
        <div className="mr-8">Price</div>
      </div>
      <div className="flex justify-between text-small pt-5 font-roboto pb-8">
        <div className="flex justify-start shadow-max">
          <div
            className={`bg-blue_four shadow-max_two p-3 w-12 h-12 ${
              count < 1 ? 'pointer-events-none' : ''
            }`}
            onClick={decrementCounter}>
            {count < 1 ? (
              <img src={MinusDisabledIcon} />
            ) : (
              <img src={MinusIcon} />
            )}
          </div>
          <div className="p-2 text-xxl w-12 h-12">{count}</div>
          <div
            className="bg-blue_four shadow-max_two p-3 w-12 h-12"
            onClick={incrementCounter}>
            <img src={PlusIcon} />
          </div>
        </div>
        <div className="flex justify-start items-center">
          <div className="mr-2">
            {' '}
            <img src={RupeesIcon} />
          </div>
          <div className=" p-2 w-12 h-12 border-solid border-1 border-gray-300 rounded-md text-xxl">
            {bagAmount}
          </div>
        </div>
      </div>
      <div className="flex justify-between">
        <button
          className="text-white h-12 rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center primary normal w-35"
          disabled={count <= 0}
          onClick={handleConfirm}>
          <p className="font-bold font-roboto">Done</p>
        </button>
        <button
          className="text-white h-12 rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center secondary normal w-3/5 text-sm"
          onClick={handleProceedWithoutBag}>
          <p className="font-bold font-roboto">Proceed without carry bag</p>
        </button>
      </div>
    </div>
  );
};
export default AddBag;
